import { store } from '../../../../../resources/frontend/js/store';

export const numberOfSameQuestions = type => {
    let amount = 0;

    store.state.quiz.questionsData.forEach(question => {
        if (question['type'] === type) {
            amount++;
        }
    });

    return amount;
};

export const chunkAnswers = (answers, count) => {
    const chunks = [];

    for (let i = 0; i < answers.length; i+= parseInt(count)) {
        const chunk  = answers.slice(i, i + parseInt(count));
        chunks.push(chunk);
    }

    return chunks;
};
